module.exports = __webpack_public_path__ + "assets/img/footer_logo_12.4eec897e.png";